import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { MembershipLevelBenefitSearchParams } from '../../shared/membership-level-benefit-search-params.model';
import { BenefitService } from '../../shared/benefit.service';
import { TranslationService } from '../../../shared/translation/translation.service';
import { BenefitType } from '../../shared/benefit-type.model';
import { AffCodeSelectorComponent } from '../../../affcode/affcode-selector/affcode-selector.component';

@Component({
  selector: 'wl-benefit-mgt-advanced-search',
  styleUrls: ['benefit-mgt-advanced-search.component.css'],
  templateUrl: 'benefit-mgt-advanced-search.component.html',
  providers: [BenefitService],
    standalone: false
})
export class BenefitMgtAdvancedSearchComponent implements OnInit {
  @Input() searchParams: MembershipLevelBenefitSearchParams;
  @ViewChild('affCodeSelector', { static: false }) affCodeSelector: AffCodeSelectorComponent;

  public memberTypes: any = [];
  public membershipLevels: any = [];
  public benefitTypes: BenefitType[] = [];
  public months: string[] = [];

  public constructor(public _benefiteService: BenefitService, public _translationService: TranslationService) {
    //this._utilService = utilService;
    //this._notifyService = notifyService;
    //this._translationService = translationService;
    //this.showAdvancedSearch = false;
    //this.benefits = new MembershipLevelBenefitSearchResult();
    //this.searchParams = new MembershipLevelBenefitSearchParams();
  }

  ngOnInit() {
    this._benefiteService.getMemberTypes().then(data => {
      this.memberTypes = data;
    });
    this._benefiteService.getMembershipLevels().then(pagedResult => {
      this.membershipLevels = pagedResult.Result;
    });
    this._benefiteService.getBenefitTypes().then(results => {
      this.benefitTypes = results;
    });
    this.months = this._translationService.getMonths();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.affCodeSelector.updateSelectedAffCodesFromValue();
  }
}
